import React from 'react'

// components
import WaiverWrapper from './WaiverWrapper'
import WaiverText from './WaiverText'
import WaiverFormWrapper from './WaiverFormWrapper'
import WaiverAccepted from './WaiverAccepted'
import WaiverFormFields from './WaiverFormFields'

const UI = props => {
  const {
    waiver, // via withQuery
    waiverForms, // via withRedux (from WaiversContainer)
    onChangeFormField, // via withEventHandlers
    onChangeConsent, // via withEventHandlers
    formErrors // via withFormResults/withState
  } = props

  const {
    title,
    body,
    version,
    waiverType,
    acceptedBy,
    createdAt,
    accept,
    reject
  } = waiver

  // find the waiverForm for this waiverType
  const waiverForm =
    waiverForms &&
    waiverForms.find(waiverForm => waiverForm.waiverType == waiverType)

  return (
    <WaiverWrapper>
      <WaiverText title={title} body={body}>
        <WaiverFormWrapper>
          {acceptedBy ? (
            <WaiverAccepted acceptedBy={acceptedBy} createdAt={createdAt} />
          ) : (
            <WaiverFormFields
              title={title}
              version={version}
              onChangeFormField={onChangeFormField}
              onChangeConsent={onChangeConsent}
              waiverType={waiverType}
              waiverForm={waiverForm}
              formErrors={formErrors}
              accept={accept}
              reject={reject}
            />
          )}
        </WaiverFormWrapper>
      </WaiverText>
    </WaiverWrapper>
  )
}

export default UI
